__turbopack_context__.v({
  "backdrop": "amenities-filter-panel-module-scss-module__DLWVIG__backdrop",
  "body": "amenities-filter-panel-module-scss-module__DLWVIG__body",
  "chipClear": "amenities-filter-panel-module-scss-module__DLWVIG__chipClear",
  "chipIcon": "amenities-filter-panel-module-scss-module__DLWVIG__chipIcon",
  "chipLead": "amenities-filter-panel-module-scss-module__DLWVIG__chipLead",
  "chipLeadStatic": "amenities-filter-panel-module-scss-module__DLWVIG__chipLeadStatic",
  "chipRow": "amenities-filter-panel-module-scss-module__DLWVIG__chipRow",
  "chipShell": "amenities-filter-panel-module-scss-module__DLWVIG__chipShell",
  "chipShellSelected": "amenities-filter-panel-module-scss-module__DLWVIG__chipShellSelected",
  "chipTrailing": "amenities-filter-panel-module-scss-module__DLWVIG__chipTrailing",
  "chipTrailingReserve": "amenities-filter-panel-module-scss-module__DLWVIG__chipTrailingReserve",
  "container": "amenities-filter-panel-module-scss-module__DLWVIG__container",
  "containerPortaled": "amenities-filter-panel-module-scss-module__DLWVIG__containerPortaled",
  "drawer": "amenities-filter-panel-module-scss-module__DLWVIG__drawer",
  "drawerHeader": "amenities-filter-panel-module-scss-module__DLWVIG__drawerHeader",
  "drawerHeaderRow": "amenities-filter-panel-module-scss-module__DLWVIG__drawerHeaderRow",
  "drawerTitle": "amenities-filter-panel-module-scss-module__DLWVIG__drawerTitle",
  "footer": "amenities-filter-panel-module-scss-module__DLWVIG__footer",
  "footerButton": "amenities-filter-panel-module-scss-module__DLWVIG__footerButton",
  "popoverContainer": "amenities-filter-panel-module-scss-module__DLWVIG__popoverContainer",
});
